// extracted by mini-css-extract-plugin
export default {"EmailsList":"emails-list_EmailsList__L5yVx","emailRow":"emails-list_emailRow__Vb4VS"};